// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1060":"ffbc812f","1694":"778d30b2","3613":"410febf8","3856":"420d24f0","4133":"db1e141e","5602":"db1e141e","9947":"ffbc812f"}[chunkId] + ".chunk.css";
};